var __templateData = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h2>\r\n  Votre panier\r\n</h2>\r\n<form id=\"form-cart\">\r\n  <div id=\"cart-list\">\r\n    <i class=\"fa fa-refresh fa-spin\"></i> Chargement en cours...\r\n  </div>\r\n</form>\r\n";
},"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}